export interface NumericCellSummary {
  count: number;
  average: number;
  sum: number;
}

export const buildCellSelectionKey = (rowId: string, field: string) => `${rowId}::${field}`;

export const isAdditiveCellSelection = (event: { ctrlKey: boolean; metaKey: boolean }) =>
  event.ctrlKey || event.metaKey;

export const resolveNumericCellValue = (...candidates: unknown[]): number | null => {
  for (const candidate of candidates) {
    if (typeof candidate === 'number' && Number.isFinite(candidate)) {
      return candidate;
    }

    if (typeof candidate !== 'string') continue;

    const normalized = candidate.trim().replace(/[\s\u00a0]/g, '');
    if (!/^-?\d+(?:[.,]\d+)?$/.test(normalized)) continue;

    const parsed = Number(normalized.replace(',', '.'));
    if (Number.isFinite(parsed)) return parsed;
  }

  return null;
};

export const summarizeNumericCells = (values: number[]): NumericCellSummary | null => {
  if (values.length === 0) return null;

  const sum = values.reduce((total, value) => total + value, 0);

  return {
    count: values.length,
    average: sum / values.length,
    sum
  };
};
